<mecap-forbidden-nickname-list-filter-panel
  [i18nParentPrefix]="i18nParentPrefix"
  [tableId]="tableId"
  (changeForm)="filter$.next($event)"
  (clickOnNew)="clickOnNew()"
/>

<mat-card class="mt-4 overflow-hidden">
  <pct-feature-table-material-table
    class="w-full"
    [columnsConfig]="columnsConfig()"
    [id]="tableId"
    [rowActionsConfig]="rowActions"
    [source]="dataSource"
    [tableSettings]="tableSettings()"
  />
</mat-card>
